import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpand = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "800px",
	height: "800px",
	viewBox: "0 0 24 12",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M23.541 3.28l-10 12a2.007 2.007 0 0 1-3.08 0l-10-12A2 2 0 0 1 2 0h20a2 2 0 0 1 1.541 3.28z"
	})
});
export default SvgExpand;
